import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from '@components/atoms';
import { AccordionChevron } from '@components/atoms/accordion';
import { BodyRegular, H2 } from '@components/atoms/typography';

const faqData = [
  {
    q: 'Are you guys really that awesome?',
    a: "Yes. But don't take our word for it. If you sign up and don't like our product, you can ask for a refund within the first 14 days."
  },
  {
    q: 'Can I cancel anytime?',
    a: 'Yes.'
  },
  {
    q: "Will I really get my money back if I don't win my mini-league?",
    a: 'Yes, as long as you follow our T&Cs <a href="https://www.fantasyfootballhub.co.uk/terms-and-conditions" target="_blank">(see section 2.6)</a>'
  },
  {
    q: 'I have a question, can I contact you?',
    a: 'Yes, <a href="https://www.fantasyfootballhub.co.uk/contact" target="_blank">here</a>.',
    link: 'https://www.fantasyfootballhub.co.uk/contact'
  },
  {
    q: 'Can I upgrade / downgrade once signed up?',
    a: "Yes, you can easily do this once signed up. Your billing will be prorated so you won't be overcharged. However, the same discounts are not always available."
  }
];

export const FAQ = () => {
  return (
    <div className="flex flex-col">
      <Accordion type="single" className="w-full" collapsible>
        <div>
          {faqData.map((item, index) => (
            <AccordionItem
              key={`faq_item_${index}`}
              value={`${index}`}
              className="my-4 rounded-sm"
            >
              <AccordionTrigger>
                <H2 className="font-sans font-semibold text-xl">{item.q}</H2>
                <AccordionChevron aria-hidden />
              </AccordionTrigger>
              <AccordionContent>
                <BodyRegular
                  className="[&>a]:text-primary [&>a]:font-open-sans [&>a]:underline [&>a]:underline-offset-2"
                  dangerouslySetInnerHTML={{ __html: item.a }}
                />
              </AccordionContent>
            </AccordionItem>
          ))}
        </div>
      </Accordion>
    </div>
  );
};
